import Script from 'next/script';
import getNextConfig from 'next/config';
import type { NextRuntimeConfiguration } from '@libs/config';
import { EnvironmentName } from '@libs/constants';
import classNames from 'classnames';
import styles from './AppVersion.module.css';
import type { ReactElement } from 'react';
import { useState } from 'react';

const { publicRuntimeConfig } = getNextConfig() as NextRuntimeConfiguration;

export const AppVersion = () => {
  let appVersionBanner: ReactElement = null;

  if (
    [EnvironmentName.WHITE, EnvironmentName.BLACK, EnvironmentName.LOCAL].includes(
      publicRuntimeConfig.envName as EnvironmentName
    )
  ) {
    const shortVersion = publicRuntimeConfig.version.replaceAll(/^(\d+\.\d+\.\d+).*/g, '$1');
    const preRelease = publicRuntimeConfig.version.match(/^\d+\.\d+\.\d+-(\w+)/);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [visible, setIsVisible] = useState(true);

    appVersionBanner = visible && (
      <div
        onClick={() => setIsVisible(false)}
        data-testid="appversion-banner"
        className={classNames({
          'py-2 text-center font-bold text-sm fixed origin-left -rotate-45 shadow-lg': true,
          '-translate-x-5 translate-y-64': preRelease !== null,
          '-translate-x-14 translate-y-56': preRelease === null,
          [styles.white]: publicRuntimeConfig.envName === EnvironmentName.WHITE,
          [styles.black]: publicRuntimeConfig.envName === EnvironmentName.BLACK,
          [styles.local]: publicRuntimeConfig.envName === EnvironmentName.LOCAL,
        })}
        style={{ width: '270px' }}
      >
        {publicRuntimeConfig.envName}&nbsp;@&nbsp;
        <span title={publicRuntimeConfig.version}>
          {shortVersion}
          {preRelease !== null && ` (${preRelease[1]})`}
        </span>
      </div>
    );
  }

  return (
    <>
      <Script id="avs" strategy="beforeInteractive">
        {`/* appversion ${publicRuntimeConfig.version} */`}
      </Script>
      {appVersionBanner}
    </>
  );
};
